import { api } from './client';
import { filasDesdeLaApi, type FilaDesempeno } from '@/lib/desempeno';

/**
 * Desempeño de técnicos (ADMIN). Prefijo: /api/tecnicos
 *
 * ⚠️ **El endpoint lo está construyendo otra tanda en paralelo.** Acá se lo
 * consume asumiendo `GET /api/tecnicos/desempeno?desde&hasta`, que devuelve una
 * fila por técnico con sus instalaciones completadas, sus garantías atendidas y
 * las garantías que cerró sin completar la ficha.
 *
 * Por eso la respuesta pasa por `filasDesdeLaApi`, que es tolerante con el
 * envoltorio y con el nombre exacto de cada campo, y por eso la pantalla trata
 * el 404 como "todavía no está", no como un error del sistema: mientras el
 * endpoint no exista, la pantalla se abre y lo dice con todas las letras.
 */
export function obtenerDesempeno(params: {
  desde: string;
  hasta: string;
}): Promise<FilaDesempeno[]> {
  return api
    .get<unknown>('/api/tecnicos/desempeno', { query: params })
    .then((crudo) => filasDesdeLaApi(crudo));
}
